export default __webpack_public_path__ + "static/media/Bifana.8c7a0f40.jpg";